export const PHAdviceOptions = {
  refund_or_return: {
    label: 'My refund or return status',
    value: 'My refund or return status'
  },
  self_filed_correctly: {
    label: 'Checking if I self-filed correctly',
    value: 'Checking if I self-filed correctly'
  },
  something_else: { label: 'Something else', value: 'Something else' }
} as const;
